export default {"src":"https://fishbrain.com/_next/static/media/stripedBass.3e84cfe1.svg","height":115,"width":230,"blurWidth":0,"blurHeight":0};